import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import CtaLinkStyles from '@stories/Components/CtaLink/CtaLink.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  text-align: center;

  &[data-background='beige'] {
    background-color: ${brand.beige};
    padding: var(--sectionSpacing) 0;
  }

  &[data-background='white'] {
    background-color: ${brand.white};
    margin: var(--sectionSpacing) auto;
  }

  ${CtaLinkStyles.Container} {
    @media ${from(Device.Desktop)} {
      display: none;
    }
  }
`;
const IframeWrapper = styled.div `
  display: none;

  @media ${from(Device.Desktop)} {
    display: block;
    position: relative;
    width: 100%;
    /* Leave vertical spacing around the iframe */
    height: max(calc(95vh - var(--headerScrollHeight, 0px), 1080px));
    min-height: 760px;
  }
`;
const Iframe = styled.iframe `
  ${imageCoverContainer()}
`;
const EmbeddedPdfLinkStyles = {
    Container,
    IframeWrapper,
    Iframe,
};
export default EmbeddedPdfLinkStyles;
